// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextPage_wrapper__1Cj0l","title-wrapper":"TextPage_title-wrapper__1zDz8","content":"TextPage_content__kbXw8"};